import React, { useCallback } from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { DataType } from '../types';

const { FormControl, RadioButtons } = inputs;

export interface StaticLiveInputProps {
  dataType: DataType;
  setDataType: (type: DataType) => void;
}

const radioButtonOptions = [
  { value: 'live', label: 'Live' },
  { value: 'static', label: 'Static' },
];

export const StaticLiveInput: React.FC<StaticLiveInputProps> = ({ dataType, setDataType }) => {
  const handleChange = useCallback(
    (type: DataType) => {
      setDataType(type);
    },
    [setDataType]
  );
  return (
    <FormControl
      name="viewDataType"
      label="Data type"
      infoMessage="Be aware that static data will expire at some point."
      labelTooltip={
        <>
          <strong>Live data</strong> updates weekly or monthly. <strong>Static data</strong> is a snapshot of the
          selected timeframe.
        </>
      }
    >
      <RadioButtons orientation={'horizontal'} value={dataType} options={radioButtonOptions} onChange={handleChange} />
    </FormControl>
  );
};
